module.exports = __webpack_public_path__ + "static/media/contact.7eb862e2.md";


//////////////////
// WEBPACK FOOTER
// ./src/markdown/contact.md
// module id = 338
// module chunks = 0